export function toBoolean(val) {
  if (val === '') return val
  return val === 'true' || val == '1'
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-qr/src/util.js
// module id = e7FP
// module chunks = 46